import { gql } from '@apollo/client';

export default gql`
fragment conditionSpec on ps_rq_condition {
    connect: rq_connect_type
}
`;
